import styled from 'styled-components';

export const Sections = styled.section`
  padding-top: 20px;
  padding-bottom: 20px;
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
`;

export const Title = styled.h2`
  color: #706d69;
  text-shadow: 1px 1px white;
  text-align: center;
  font-weight: 500;
  font-size: 30px;
`;
